export const colors = ['#22c55e','#3b82f6','#f97316','#a855f7','#06b6d4','#eab308'];
export const groupColors = ['#1e40af','#065f46','#92400e','#7c3aed','#0f766e','#7f1d1d'];
export const sectorOptions = [
    '科技',
    '消费',
    '医药',
    '新能源',
    '金融',
    '银行',
    '公用事业',
    '能源',
    '半导体',
    '军工',
    '高端制造'
]

export const marketOptions = {
    'HK':'港股',
    'US':'美股'
}

export const DEFAULT_BENCHMARK = '恒生指数'

export const benchmarkOptions = [
    { value: '恒生指数', label: '恒生指数' },
    { value: '沪深300', label: '沪深300' },
    { value: '纳指100', label: '纳指100' },
    { value: '标普500', label: '标普500' },
]

/** 将历史/别名基准名规范为当前可选项 */
export function normalizeBenchmarkLabel(benchmark?: string | null): string {
    if (!benchmark) {
        return DEFAULT_BENCHMARK
    }
    if (benchmark === '纳斯达克') {
        return '纳指100'
    }
    if (benchmarkOptions.some((item) => item.value === benchmark)) {
        return benchmark
    }
    return DEFAULT_BENCHMARK
}